import { Row, Col, Button } from 'reactstrap';
import React from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidV4 } from 'uuid';
import moment from 'moment';
import entityComposition from '../common/classes/entityComposition';
import DateTimePicker from '../common/controls/dateTimePicker';
import AssetMaintenanceItem from './assetMaintenanceItem';
import Icon from '../common/containers/icon';
class AssetMaintenance extends React.Component {
  componentDidMount() {
    const {
      assetMaintenanceDescription,
      assetMaintenanceDescriptionActions,
      assetMaintenanceType,
      assetMaintenanceTypeActions,
      assetMaintenanceFrequencyUnit,
      assetMaintenanceFrequencyUnitActions
    } = this.props;
    assetMaintenanceDescriptionActions.serverIndex(assetMaintenanceDescription.indexQuery);
    assetMaintenanceTypeActions.serverIndex(assetMaintenanceType.indexQuery);
    assetMaintenanceFrequencyUnitActions.serverIndex(assetMaintenanceFrequencyUnit.indexQuery);
  }
  render() {
    const {
      assetActions,
      asset: {
        id: assetID,
        lastMaintenance,
        maintenance
      },
      userID,
      assetMaintenanceDescription,
      assetMaintenanceType,
      assetMaintenanceFrequencyUnit
    } = this.props;
    const handleChange = (name, value) => assetActions.change(assetID, name, value);
    const handleAdd = () => {
      const newMaintenace = JSON.parse(JSON.stringify(maintenance || []));
      newMaintenace.push({
        id: uuidV4(),
        assetID,
        appCreatorID: userID,
        appCreated: moment().utc().format('YYYY-MM-DD HH:mm:ss')
      });
      handleChange('maintenance', newMaintenace);
    };
    const handleRemove = index => {
      const newMaintenace = JSON.parse(JSON.stringify(maintenance));
      newMaintenace.splice(index, 1);
      handleChange('maintenance', newMaintenace);
    };
    const handleLastChange = value => {
      handleChange('lastMaintenance', value);
    };
    return /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("h2", null, "Maintenance"), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(DateTimePicker, {
      onChange: handleLastChange,
      label: "Last Maintenance Date",
      defaultValue: lastMaintenance
    }))), (maintenance || []).map((nextMaint, index) => /*#__PURE__*/React.createElement(AssetMaintenanceItem, {
      maintenance: nextMaint,
      key: nextMaint.id,
      index: index,
      onChange: handleChange,
      onRemove: handleRemove,
      assetMaintenanceDescriptionList: assetMaintenanceDescription.list,
      assetMaintenanceTypeList: assetMaintenanceType.list,
      assetMaintenanceFrequencyUnitList: assetMaintenanceFrequencyUnit.list
    })), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: {
        size: 3,
        offset: 9
      }
    }, /*#__PURE__*/React.createElement(Button, {
      size: "sm",
      onClick: handleAdd,
      className: "form-control t-am-add-maintenance tqc-control"
    }, /*#__PURE__*/React.createElement(Icon, {
      glyph: "plus"
    }), " Add Maintenance"))));
  }
}
AssetMaintenance.propTypes = {
  asset: PropTypes.shape({
    id: PropTypes.string,
    lastMaintenance: PropTypes.string,
    maintenance: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  assetActions: PropTypes.shape({
    change: PropTypes.func
  }).isRequired,
  userID: PropTypes.string.isRequired,
  assetMaintenanceDescription: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  assetMaintenanceDescriptionActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  assetMaintenanceType: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  assetMaintenanceTypeActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  assetMaintenanceFrequencyUnit: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  assetMaintenanceFrequencyUnitActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired
};
export { AssetMaintenance as TestAssetMaintenance };
export default entityComposition(AssetMaintenance, ['assetMaintenanceDescription', 'assetMaintenanceType', 'assetMaintenanceFrequencyUnit']);